import React from 'react'

function Error() {
    return (
        <div>
            ERROR
        </div>
    )
}

export default Error
